import React from "react";
import { connect } from "react-redux";
import { setTonerRecycleBox } from "../redux/actions";
import { Form, Row, Col } from "react-bootstrap";
import {isTonerRecycleBoxValid, validateRecycleBox} from "../redux/selectors"

function TonerRecycle({
  tonerRecycleBox,
  setTonerRecycleBox,
  isTonerRecycleBoxValid,
  validateRecycleBox
}) {
  return (
    <>
      <Form.Group as={Row} controlId="financeSubtype">
        <Form.Label sm={2} column>
          Toner Recycle Box
        </Form.Label>
        <Col sm={1}>
          <Form.Control
            as="select"
            onChange={e => setTonerRecycleBox(e.target.value)}
            value={tonerRecycleBox}
            isInvalid={!isTonerRecycleBoxValid}
          >
            <option value="1">Yes</option>
            <option value="0">No</option>
          </Form.Control>
        </Col>
        {!isTonerRecycleBoxValid ?
        <Col sm={4}>
          <span style={{color: "red", fontWeight: "bold"}}>{validateRecycleBox}</span>
        </Col>
        : null}
      </Form.Group>
    </>
  );
}

export default connect(
  state => ({
    tonerRecycleBox: state.quote.tonerRecycleBox,
    isTonerRecycleBoxValid: isTonerRecycleBoxValid(state),
    validateRecycleBox: validateRecycleBox(state),
  }),
  { setTonerRecycleBox }
)(TonerRecycle);
